import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { RouterOutlet } from "@angular/router";

import { NavigationService } from "./shared/services/navigation.service";
import { HomeScreenLaunchService } from "./shared/services/home-screen-launch.service";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [RouterOutlet]
})
export class AppComponent {
    // Injected to eagerly construct NavigationService at bootstrap, starting its route-tracking subscription.
    private readonly _navigationService = inject(NavigationService);
    // Constructed at bootstrap so it captures the URL a home-screen app was launched with.
    private readonly _homeScreenLaunchService = inject(HomeScreenLaunchService);
}
